import { createSlice } from "@reduxjs/toolkit";
import { getfbCampaignList } from "./ThunkActions";
import { ifbCampaignState, REDUCER_NAME } from "./Types";

// Define initial state based on the provided structure
const initialState: ifbCampaignState = {
  isLoading: false,
  fbCampaignList: [],
  errorMessage: null,
};

export const fbCampaignSlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetfbCampaignState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getfbCampaignList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getfbCampaignList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.fbCampaignList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getfbCampaignList.rejected, (state) => {
        state.errorMessage = "Failed to fetch campaign list";
        state.isLoading = false;
      });
  },
});

export const { resetfbCampaignState } = fbCampaignSlice.actions;
export default fbCampaignSlice.reducer;
